module.exports = __webpack_public_path__ + "static/media/origin-regs-logo.b16a1143.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/origin-regs-logo.png
// module id = 807
// module chunks = 0